import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export const PARTNER_CASHBACK_SUMMARY_QUERY_KEY = ['GET_PARTNER_CASHBACK_SUMMARY'];

export const useGetPartnerCashbackSummaryQuery = () => {
  const { getPartnerCashbackSummary } = useServicesContext();

  return useQuery({
    queryKey: PARTNER_CASHBACK_SUMMARY_QUERY_KEY,
    queryFn: getPartnerCashbackSummary,
  });
};
